/**
 * Platform-agnostic Map Component
 * Renders native WebView map on mobile, react-leaflet on web
 */

import React from 'react';
import { Platform } from 'react-native';
import { LeafletMapWithOverlay } from './LeafletMapWithOverlay';
import { LeafletMapWeb } from './LeafletMapWeb';

interface PlatformMapProps {
  center: { lat: number; lng: number };
  zoom: number;
  markers: Array<{
    position: { lat: number; lng: number };
    icon: string;
    size: [number, number];
    title: string;
    temperature?: number;
    chlorophyll?: number;
    currentSpeed?: number;
    currentDirection?: number;
    ssh?: number;
    type?: string;
    noCluster?: boolean;
    hotspotNumber?: number;
    confidence?: number;
    score?: number;
    reasons?: string[];
    gradients?: string[];
    nearbyStructures?: any[];
    buoyData?: any;
    description?: string;
    category?: string;
  }>;
  overlays?: Array<{
    url: string;
    bounds: {
      minLat: number;
      maxLat: number;
      minLon: number;
      maxLon: number;
    };
    zIndex?: number;
    type?: 'image' | 'tile' | 'custom-bag' | 'custom-multibeam';
    opacity?: number;
  }>;
  shapes?: Array<{
    shapeType: 'polyline';
    positions: Array<{ lat: number; lng: number }>;
    color?: string;
    weight?: number;
    distance?: number;
  }>;
  onMapClick?: (lat: number, lng: number) => void;
  onMapLongPress?: (lat: number, lng: number) => void;
  onMarkerClick?: (position: { lat: number; lng: number }) => void;
  onMapMove?: (center: { lat: number; lng: number }, zoom: number, bounds: { minLat: number; maxLat: number; minLon: number; maxLon: number }) => void;
  enableClustering?: boolean;
  baseMapType?: 'street' | 'ocean';
}

export const PlatformMap: React.FC<PlatformMapProps> = (props) => {
  if (Platform.OS === 'web') {
    return <LeafletMapWeb {...props} />;
  }

  return <LeafletMapWithOverlay {...props} />;
};
